// Galaxia Pro — Icon set (ESM, typed)
// Stroke-based, 24×24 viewBox, stroke-width 1.8.
// Mirror of `../icons.jsx` plus `google` and `microsoft` for SSO.

import type { JSX, SVGProps } from "react";

export const ICON_PATHS = {
  home: '<path d="M3 11l9-8 9 8"/><path d="M5 10v10h14V10"/>',
  pos: '<rect x="3" y="4" width="18" height="16" rx="2"/><path d="M3 9h18M8 14h2M12 14h4"/>',
  chart: '<path d="M3 20h18M6 16V9M10 16V5M14 16v-7M18 16v-4"/>',
  money:
    '<circle cx="12" cy="12" r="9"/><path d="M12 7v10M9 10c0-1.5 6-1.5 6 0s-6 1.5-6 3 6 1.5 6 0"/>',
  route:
    '<circle cx="6" cy="6" r="2"/><circle cx="18" cy="18" r="2"/><path d="M8 6h6a4 4 0 014 4v0a4 4 0 01-4 4H10a4 4 0 00-4 4v0"/>',
  users:
    '<circle cx="9" cy="8" r="3"/><path d="M3 20c0-3 3-5 6-5s6 2 6 5"/><circle cx="17" cy="9" r="2.5"/><path d="M15 14c2 0 6 1.5 6 5"/>',
  box: '<path d="M3 7l9-4 9 4v10l-9 4-9-4V7z"/><path d="M3 7l9 4 9-4M12 11v10"/>',
  settings:
    '<circle cx="12" cy="12" r="3"/><path d="M12 2v3M12 19v3M4 12H1M23 12h-3M6 6L4 4M20 20l-2-2M6 18l-2 2M20 4l-2 2"/>',
  bell: '<path d="M18 16v-6a6 6 0 10-12 0v6l-2 2h16l-2-2z"/><path d="M10 20a2 2 0 004 0"/>',
  search: '<circle cx="11" cy="11" r="7"/><path d="M21 21l-5-5"/>',
  plus: '<path d="M12 5v14M5 12h14"/>',
  menu: '<path d="M3 6h18M3 12h18M3 18h18"/>',
  star: '<path d="M12 2l3 7h7l-5.5 4.5L18 21l-6-4-6 4 1.5-7.5L2 9h7z"/>',
  trend: '<path d="M3 17l6-6 4 4 8-8"/><path d="M17 7h4v4"/>',
  clock: '<circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/>',
  map: '<path d="M9 3L3 6v15l6-3 6 3 6-3V3l-6 3-6-3z"/><path d="M9 3v15M15 6v15"/>',
  check: '<path d="M4 12l5 5L20 6"/>',
  arrow: '<path d="M5 12h14M13 6l6 6-6 6"/>',
  donut: '<circle cx="12" cy="12" r="9"/><circle cx="12" cy="12" r="3"/>',
  truck:
    '<rect x="1" y="6" width="14" height="10" rx="1"/><path d="M15 9h4l3 4v3h-7"/><circle cx="5" cy="18" r="2"/><circle cx="18" cy="18" r="2"/>',
  card: '<rect x="2" y="5" width="20" height="14" rx="2"/><path d="M2 10h20M6 15h4"/>',
  filter: '<path d="M3 4h18l-7 9v6l-4 2v-8z"/>',
  x: '<path d="M6 6l12 12M6 18L18 6"/>',
  edit: '<path d="M4 20h4L19 9l-4-4L4 16v4z"/><path d="M14 6l4 4"/>',
  trash:
    '<path d="M4 7h16M10 11v6M14 11v6M6 7l1 13h10l1-13M9 7V4h6v3"/>',
  download: '<path d="M12 3v13M6 11l6 6 6-6M4 21h16"/>',
  print:
    '<rect x="6" y="4" width="12" height="6"/><rect x="6" y="14" width="12" height="6"/><path d="M6 10H4a2 2 0 00-2 2v4a2 2 0 002 2h2M18 10h2a2 2 0 012 2v4a2 2 0 01-2 2h-2"/>',
  eye: '<path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7S2 12 2 12z"/><circle cx="12" cy="12" r="3"/>',
  "eye-off":
    '<path d="M3 3l18 18M10.6 10.6a3 3 0 004.2 4.2"/><path d="M9.4 5.5C10.2 5.2 11 5 12 5c6.5 0 10 7 10 7-.6 1.2-1.5 2.4-2.6 3.5M6.6 6.6C4 8.4 2 12 2 12s3.5 7 10 7c1.7 0 3.2-.4 4.6-1"/>',
  // SSO logos (simplified, currentColor for monochrome rendering).
  // The button supplies its own color via CSS; consumers MUST NOT
  // hardcode brand colors here. Per Galaxia Pro DS rules.
  google:
    '<path d="M21.6 12.2c0-.7-.1-1.3-.2-1.9H12v3.7h5.4c-.2 1.2-.9 2.2-1.9 2.9v2.4h3.1c1.8-1.7 2.9-4.2 2.9-7.1z"/><path d="M12 22c2.6 0 4.8-.9 6.4-2.4l-3.1-2.4c-.9.6-2 .9-3.3.9-2.5 0-4.7-1.7-5.4-4H3.4v2.5C5 19.9 8.3 22 12 22z" opacity=".75"/><path d="M6.6 14.1c-.2-.6-.3-1.2-.3-1.9s.1-1.3.3-1.9V7.8H3.4C2.8 9.1 2.4 10.5 2.4 12s.4 2.9 1 4.2l3.2-2.1z" opacity=".5"/><path d="M12 6c1.4 0 2.7.5 3.7 1.4L18.4 4.7C16.7 3.1 14.5 2 12 2 8.3 2 5 4.1 3.4 7.2L6.6 9.7c.7-2.3 2.9-4 5.4-4z" opacity=".25"/>',
  microsoft:
    '<rect x="2" y="2" width="9" height="9"/><rect x="13" y="2" width="9" height="9" opacity=".7"/><rect x="2" y="13" width="9" height="9" opacity=".5"/><rect x="13" y="13" width="9" height="9" opacity=".85"/>',
  // Clipboard / copy — par de hojas. Para botones "copiar al
  // portapapeles" (UX de typed-confirm + share links).
  copy:
    '<rect x="9" y="9" width="12" height="12" rx="2"/><path d="M5 15H4a2 2 0 01-2-2V4a2 2 0 012-2h9a2 2 0 012 2v1"/>',
  // Chevrons — indicadores direccionales para expand/collapse,
  // dropdowns, breadcrumbs. NO usar `x` para colapsar (sugiere
  // "eliminar" / "cerrar").
  "chevron-down": '<path d="M6 9l6 6 6-6"/>',
  "chevron-up": '<path d="M18 15l-6-6-6 6"/>',
  "chevron-right": '<path d="M9 6l6 6-6 6"/>',
  "chevron-left": '<path d="M15 6l-6 6 6 6"/>',
  calendar:
    '<rect x="3" y="4" width="18" height="18" rx="2"/><path d="M3 10h18M8 2v4M16 2v4"/>',
  // Sparkles — indicador de "IA generativa" / "regeneración con
  // modelo". Usar específicamente para acciones que invocan modelos
  // (gpt-image-1, etc.) y consumen tokens. Tres destellos: el grande
  // en el centro + dos pequeños en los costados (pattern Lucide
  // "sparkles" simplificado a 4 puntas y 24×24).
  sparkles:
    '<path d="M12 3l1.6 4.4L18 9l-4.4 1.6L12 15l-1.6-4.4L6 9l4.4-1.6z"/><path d="M19 13l.7 1.9L21.6 16l-1.9.7L19 19l-.7-1.9L16.4 16l1.9-.7z"/><path d="M5 4l.6 1.4L7 6l-1.4.6L5 8l-.6-1.4L3 6l1.4-.6z"/>',
} as const;

export type IconName = keyof typeof ICON_PATHS;

export interface IconProps extends Omit<SVGProps<SVGSVGElement>, "name"> {
  name: IconName;
  size?: number;
  color?: string;
  strokeWidth?: number;
}

export function Icon({
  name,
  size = 20,
  color = "currentColor",
  strokeWidth = 1.8,
  ...rest
}: IconProps): JSX.Element {
  const inner = ICON_PATHS[name] || "";
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      dangerouslySetInnerHTML={{ __html: inner }}
      {...rest}
    />
  );
}
